import { useEffect, useMemo } from 'react';
import debounce from '@/utils/debounce';
import is from '@/utils/is';

const useListenWindowEvent = (
  event: keyof WindowEventMap | string,
  listener: (ev: Event | CustomEvent<any>) => void,
  delay?: number,
) => {
  const debouncedListener = useMemo(() => debounce(listener, delay || 100), [listener, delay]);

  const isClient = useMemo(() => is.client(), []);

  useEffect(() => {
    if (isClient) {
      window.addEventListener(event, debouncedListener);
    }

    return () => {
      if (isClient) {
        window.removeEventListener(event, debouncedListener);
      }
    };
  }, [debouncedListener, isClient, event]);
};

export default useListenWindowEvent;
